export default "__VITE_ASSET__Ciw6l3Xh__"